// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modal Backdrop */
.availability-specific-modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    overflow-y: auto; 
}

/* Modal Content */
.availability-specific-modal-content {
    background-color: var(--clr-grey-10); 
    padding: 2rem;
    border-radius: 12px;
    box-shadow: var(--shadow-3); 
    max-width: 650px;
    width: 100%;
    max-height: 85vh;
    overflow-y: auto; 
    position: relative;
    animation: slideIn 0.4s ease-in-out; 
}

/* Slide-in animation for modal */
@keyframes slideIn {
    from {
        opacity: 0;
        transform: translateY(-30px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* Modal Header */
.availability-specific-modal-header {
    font-size: 1.6rem; 
    font-weight: bold;
    color: var(--clr-grey-1); 
    text-align: center; 
    margin-bottom: 20px;
    letter-spacing: 0.05em; 
    text-transform: uppercase; 
    padding-bottom: 10px; 
    
    /* Box Shadow for Depth */
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1); 
    background-color: var(--clr-grey-10); 
    border-radius: var(--borderRadius); 
    padding: 15px 20px; 
    
    /* Border Bottom */
    border-bottom: 3px solid var(--clr-primary-5); 
    animation: fadeIn 0.5s ease-in-out; 
}

/* Optional Header Hover Effect */
.availability-specific-modal-header:hover {
    background-color: var(--clr-primary-9); 
    color: var(--clr-primary-1); 
    box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.2); 
}

/* Keyframe for fade-in animation */
@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(-20px); 
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}


/* Selected Date Info */
.availability-specific-selected-date {
    font-size: 1rem;
    color: var(--clr-primary-5); 
    /* background-color: var(--clr-primary-9);  */
    padding: 0.8rem;
    border-radius: 6px;
    text-align: center;
    margin-bottom: 20px;
    border: 1px solid var(--clr-primary-5); 
    box-shadow: var(--shadow-1); 
}

/* Availability Type (Radio Buttons) */
.availability-specific-availability-group {
    display: flex;
    justify-content: center;
    gap: 1.5rem;
    margin-bottom: 1.5rem;
}

.availability-specific-radio-label {
    font-size: 1.1rem;
    color: var(--clr-grey-2);
    font-weight: 500;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 10px;
}

.availability-specific-radio-input {
    accent-color: var(--clr-primary-4); 
    width: 18px;
    height: 18px;
}

/* Time Input Fields */
/* Time Selection Container */
.availability-specific-custom-time-selection {
    background-color: var(--clr-grey-9); 
    padding: 20px;
    border-radius: 10px;
    border: 1px solid var(--grey-300);
    box-shadow: var(--shadow-1); 
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-bottom: 20px;
    transition: all 0.3s ease-in-out;
  }
  
  /* Grouping of Start and End Time */
  .availability-specific-time-label-group {
    display: flex;
    justify-content: space-between; 
    gap: 1.5rem;
  }
  
  /* Labels Styling */
  .availability-specific-label {
    font-size: 1.1rem;
    font-weight: 600;
    color: var(--clr-grey-2); 
    display: flex;
    flex-direction: column; 
    gap: 0.5rem; 
  }
  
  /* Time Input Field Styling */
  .availability-specific-time-input {
    padding: 12px 16px;
    border-radius: 8px;
    border: 1px solid var(--grey-300); 
    font-size: 1.1rem;
    font-weight: 500;
    box-shadow: inset 0px 2px 4px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease-in-out;
    background-color: var(--clr-white);
  }
  
  /* Time Input Hover and Focus */
  .availability-specific-time-input:hover {
    border-color: var(--clr-primary-6); 
  }
  
  .availability-specific-time-input:focus {
    border-color: var(--clr-primary-6);
    box-shadow: 0px 0px 5px rgba(0, 121, 107, 0.5); 
    outline: none;
  }
  
  
/* Recurring Options Container */
.availability-specific-recurring-options {
    padding: 15px;
    border: 1px solid var(--clr-grey-300); 
    border-radius: var(--borderRadius); 
    background-color: var(--clr-grey-9); 
    margin-bottom: 20px;
    box-shadow: var(--shadow-1); 
    transition: all 0.3s ease;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
}

/* Recurrence Checkbox Label */
.availability-specific-checkbox-label {
    font-size: 1rem;
    color: var(--clr-grey-4); 
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
}

/* Checkbox Input */
.availability-specific-checkbox-input {
    transform: scale(1.2); 
    accent-color: var(--clr-primary-5); 
}

/* Recurrence Type and End Date Row */
.availability-specific-recurring-row {
    display: flex;
    justify-content: space-between;
    gap: 1.5rem;
}

/* Labels for Recurrence and Date Inputs */
.availability-specific-label {
    display: flex;
    flex-direction: column;
    font-size: 1rem;
    color: var(--clr-grey-3); 
    font-weight: 600;
}

/* Recurrence Type Select Input */
.availability-specific-select {
    padding: 12px 16px;
    border-radius: var(--borderRadius);
    border: 1px solid var(--clr-grey-300); 
    font-size: 1rem;
    background-color: var(--clr-white); 
    box-shadow: inset 0px 2px 4px rgba(0, 0, 0, 0.1); 
    transition: border-color 0.3s ease-in-out;
}

/* Select Hover and Focus */
.availability-specific-select:hover,
.availability-specific-select:focus {
    border-color: var(--clr-primary-6); 
    outline: none;
    box-shadow: 0px 0px 5px rgba(0, 121, 107, 0.3); 
}

/* End Recurrence Date Input */
.availability-specific-date-input {
    padding: 12px 16px;
    border-radius: var(--borderRadius);
    border: 1px solid var(--clr-grey-300); 
    font-size: 1rem;
    background-color: var(--clr-white); 
    box-shadow: inset 0px 2px 4px rgba(0, 0, 0, 0.1); 
    transition: border-color 0.3s ease-in-out;
}

/* Date Input Hover and Focus */
.availability-specific-date-input:hover,
.availability-specific-date-input:focus {
    border-color: var(--clr-primary-6); 
    outline: none;
    box-shadow: 0px 0px 5px rgba(0, 121, 107, 0.3); 
}

/* Validation Error */
.validation-error {
    color: var(--red-dark); 
    font-size: 0.95rem;
    text-align: center;
    margin-top: -10px;
    margin-bottom: 20px;
}

/* Delete Confirmation Section */
.delete-confirmation-section {
    margin-top: 1rem;
    margin-bottom: 1.5rem;
    padding: 10px;
    background-color: var(--clr-grey-9); 
    border: 1px solid var(--grey-300);
    border-radius: 8px;
  }
  
  /* Delete Confirmation Text */
  .delete-confirmation-text {
    font-size: 1rem;
    font-weight: 500;
    color: var(--clr-grey-4);
    margin-bottom: 0.5rem;
  }
  
  /* Delete Confirmation Label */
  .delete-confirmation-label {
    display: flex;
    align-items: center;
    font-size: 1rem;
    font-weight: 500;
    color: var(--clr-grey-3);
  }
  
  .delete-confirmation-label input {
    margin-right: 8px;
  }
  
.delete-confirmation-section input {
    transform: scale(1.2);
    accent-color: var(--red-dark); 
}

/* Modal Buttons */
.availability-specific-modal-buttons {
    display: flex;
    justify-content: space-between;
    gap: 1.2rem;
}

.availability-specific-modal-save-button,
.availability-specific-modal-cancel-button {
    flex: 1 1;
    padding: 0.9rem 1.2rem;
    font-size: 1.1rem;
    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.3s ease, transform 0.2s;
}

/* Save Button */
.availability-specific-modal-save-button {
    background-color: var(--clr-primary-5);
    color: var(--clr-white);
    border: none;
}

.availability-specific-modal-save-button:hover {
    background-color: var(--clr-primary-3); 
    transform: scale(1.03);
}

/* Disabled Save Button */
.availability-specific-modal-save-button:disabled {
    background-color: var(--clr-grey-4);
    cursor: not-allowed;
    opacity: 0.7;
}

/* Cancel Button */
.availability-specific-modal-cancel-button {
    background-color: var(--clr-grey-6);
    color: var(--clr-white);
    border: none;
}

.availability-specific-modal-cancel-button:hover {
    background-color: var(--clr-grey-4); 
    transform: scale(1.03);
}

/* Delete Button */
.availability-specific-modal-delete-button {
    background-color: palevioletred;
    color: var(--clr-white);
    border: none;
    flex: 1 1;
    padding: 0.9rem 1.2rem;
    font-size: 1.1rem;
    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.3s ease, transform 0.2s;
}

.availability-specific-modal-delete-button:disabled {
    background-color: var(--red-light);
    cursor: not-allowed;
}

.availability-specific-modal-delete-button:hover {
    background-color: var(--red-dark); 
}

/* Responsive Design */

@media (max-width: 768px) {
    .availability-specific-modal-content {
        padding: 1.2rem;
        width: 95%;
    }

    .availability-specific-modal-buttons {
        flex-direction: column;
        gap: 0.8rem;
    }

    .availability-specific-modal-save-button,
    .availability-specific-modal-cancel-button {
        width: 100%;
    }
}

/* Highlighted Date Styling */
.highlighted-date {
    font-weight: bold; 
    color: var(--clr-primary-5); 
    background-color: var(--clr-primary-9); 
    padding: 2px 6px; 
    border-radius: 4px; 
    box-shadow: var(--shadow-1); 
}

@media (max-width: 768px) {
    .availability-specific-recurring-row {
        flex-direction: column;
        gap: 1rem;
    }
}


 /* Responsive Time Input for Small Screens */
 @media (max-width: 768px) {
    .availability-specific-time-label-group {
      flex-direction: column;
      gap: 1rem; 
    }
  
    .availability-specific-time-input {
      width: 100%;
    }
  }

  .availability-specific-modal-save-button.disabled {
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
    background-color: #ccc; 
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Scheduling/styles/DoctorAvailabilityModal.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,gBAAgB;AACpB;;AAEA,kBAAkB;AAClB;IACI,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,mCAAmC;AACvC;;AAEA,iCAAiC;AACjC;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA,iBAAiB;AACjB;IACI,iBAAiB;IACjB,iBAAiB;IACjB,wBAAwB;IACxB,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;IACzB,oBAAoB;;IAEpB,yBAAyB;IACzB,0CAA0C;IAC1C,oCAAoC;IACpC,kCAAkC;IAClC,kBAAkB;;IAElB,kBAAkB;IAClB,6CAA6C;IAC7C,kCAAkC;AACtC;;AAEA,iCAAiC;AACjC;IACI,sCAAsC;IACtC,2BAA2B;IAC3B,2CAA2C;AAC/C;;AAEA,mCAAmC;AACnC;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;;AAGA,uBAAuB;AACvB;IACI,eAAe;IACf,2BAA2B;IAC3B,6CAA6C;IAC7C,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,sCAAsC;IACtC,2BAA2B;AAC/B;;AAEA,sCAAsC;AACtC;IACI,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,wBAAwB;IACxB,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,kCAAkC;IAClC,WAAW;IACX,YAAY;AAChB;;AAEA,sBAAsB;AACtB,6BAA6B;AAC7B;IACI,mCAAmC;IACnC,aAAa;IACb,mBAAmB;IACnB,iCAAiC;IACjC,2BAA2B;IAC3B,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB,gCAAgC;EAClC;;EAEA,mCAAmC;EACnC;IACE,aAAa;IACb,8BAA8B;IAC9B,WAAW;EACb;;EAEA,mBAAmB;EACnB;IACE,iBAAiB;IACjB,gBAAgB;IAChB,wBAAwB;IACxB,aAAa;IACb,sBAAsB;IACtB,WAAW;EACb;;EAEA,6BAA6B;EAC7B;IACE,kBAAkB;IAClB,kBAAkB;IAClB,iCAAiC;IACjC,iBAAiB;IACjB,gBAAgB;IAChB,gDAAgD;IAChD,gCAAgC;IAChC,kCAAkC;EACpC;;EAEA,+BAA+B;EAC/B;IACE,kCAAkC;EACpC;;EAEA;IACE,kCAAkC;IAClC,8CAA8C;IAC9C,aAAa;EACf;;;AAGF,gCAAgC;AAChC;IACI,aAAa;IACb,qCAAqC;IACrC,kCAAkC;IAClC,mCAAmC;IACnC,mBAAmB;IACnB,2BAA2B;IAC3B,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA,8BAA8B;AAC9B;IACI,eAAe;IACf,wBAAwB;IACxB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA,mBAAmB;AACnB;IACI,qBAAqB;IACrB,kCAAkC;AACtC;;AAEA,qCAAqC;AACrC;IACI,aAAa;IACb,8BAA8B;IAC9B,WAAW;AACf;;AAEA,0CAA0C;AAC1C;IACI,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA,iCAAiC;AACjC;IACI,kBAAkB;IAClB,kCAAkC;IAClC,qCAAqC;IACrC,eAAe;IACf,kCAAkC;IAClC,gDAAgD;IAChD,yCAAyC;AAC7C;;AAEA,2BAA2B;AAC3B;;IAEI,kCAAkC;IAClC,aAAa;IACb,8CAA8C;AAClD;;AAEA,8BAA8B;AAC9B;IACI,kBAAkB;IAClB,kCAAkC;IAClC,qCAAqC;IACrC,eAAe;IACf,kCAAkC;IAClC,gDAAgD;IAChD,yCAAyC;AAC7C;;AAEA,+BAA+B;AAC/B;;IAEI,kCAAkC;IAClC,aAAa;IACb,8CAA8C;AAClD;;AAEA,qBAAqB;AACrB;IACI,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA,gCAAgC;AAChC;IACI,gBAAgB;IAChB,qBAAqB;IACrB,aAAa;IACb,mCAAmC;IACnC,iCAAiC;IACjC,kBAAkB;EACpB;;EAEA,6BAA6B;EAC7B;IACE,eAAe;IACf,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;EACvB;;EAEA,8BAA8B;EAC9B;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,wBAAwB;EAC1B;;EAEA;IACE,iBAAiB;EACnB;;AAEF;IACI,qBAAqB;IACrB,6BAA6B;AACjC;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,8BAA8B;IAC9B,WAAW;AACf;;AAEA;;IAEI,SAAO;IACP,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,sDAAsD;AAC1D;;AAEA,gBAAgB;AAChB;IACI,sCAAsC;IACtC,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,sCAAsC;IACtC,sBAAsB;AAC1B;;AAEA,yBAAyB;AACzB;IACI,mCAAmC;IACnC,mBAAmB;IACnB,YAAY;AAChB;;AAEA,kBAAkB;AAClB;IACI,mCAAmC;IACnC,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,mCAAmC;IACnC,sBAAsB;AAC1B;;AAEA,kBAAkB;AAClB;IACI,+BAA+B;IAC/B,uBAAuB;IACvB,YAAY;IACZ,SAAO;IACP,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,sDAAsD;AAC1D;;AAEA;IACI,kCAAkC;IAClC,mBAAmB;AACvB;;AAEA;IACI,iCAAiC;AACrC;;AAEA,sBAAsB;;AAEtB;IACI;QACI,eAAe;QACf,UAAU;IACd;;IAEA;QACI,sBAAsB;QACtB,WAAW;IACf;;IAEA;;QAEI,WAAW;IACf;AACJ;;AAEA,6BAA6B;AAC7B;IACI,iBAAiB;IACjB,2BAA2B;IAC3B,sCAAsC;IACtC,gBAAgB;IAChB,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI;QACI,sBAAsB;QACtB,SAAS;IACb;AACJ;;;CAGC,4CAA4C;CAC5C;IACG;MACE,sBAAsB;MACtB,SAAS;IACX;;IAEA;MACE,WAAW;IACb;EACF;;EAEA;IACE,YAAY;IACZ,mBAAmB;IACnB,oBAAoB;IACpB,sBAAsB;EACxB","sourcesContent":["/* Modal Backdrop */\n.availability-specific-modal-backdrop {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.6);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n    overflow-y: auto; \n}\n\n/* Modal Content */\n.availability-specific-modal-content {\n    background-color: var(--clr-grey-10); \n    padding: 2rem;\n    border-radius: 12px;\n    box-shadow: var(--shadow-3); \n    max-width: 650px;\n    width: 100%;\n    max-height: 85vh;\n    overflow-y: auto; \n    position: relative;\n    animation: slideIn 0.4s ease-in-out; \n}\n\n/* Slide-in animation for modal */\n@keyframes slideIn {\n    from {\n        opacity: 0;\n        transform: translateY(-30px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n/* Modal Header */\n.availability-specific-modal-header {\n    font-size: 1.6rem; \n    font-weight: bold;\n    color: var(--clr-grey-1); \n    text-align: center; \n    margin-bottom: 20px;\n    letter-spacing: 0.05em; \n    text-transform: uppercase; \n    padding-bottom: 10px; \n    \n    /* Box Shadow for Depth */\n    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1); \n    background-color: var(--clr-grey-10); \n    border-radius: var(--borderRadius); \n    padding: 15px 20px; \n    \n    /* Border Bottom */\n    border-bottom: 3px solid var(--clr-primary-5); \n    animation: fadeIn 0.5s ease-in-out; \n}\n\n/* Optional Header Hover Effect */\n.availability-specific-modal-header:hover {\n    background-color: var(--clr-primary-9); \n    color: var(--clr-primary-1); \n    box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.2); \n}\n\n/* Keyframe for fade-in animation */\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n        transform: translateY(-20px); \n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n\n/* Selected Date Info */\n.availability-specific-selected-date {\n    font-size: 1rem;\n    color: var(--clr-primary-5); \n    /* background-color: var(--clr-primary-9);  */\n    padding: 0.8rem;\n    border-radius: 6px;\n    text-align: center;\n    margin-bottom: 20px;\n    border: 1px solid var(--clr-primary-5); \n    box-shadow: var(--shadow-1); \n}\n\n/* Availability Type (Radio Buttons) */\n.availability-specific-availability-group {\n    display: flex;\n    justify-content: center;\n    gap: 1.5rem;\n    margin-bottom: 1.5rem;\n}\n\n.availability-specific-radio-label {\n    font-size: 1.1rem;\n    color: var(--clr-grey-2);\n    font-weight: 500;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.availability-specific-radio-input {\n    accent-color: var(--clr-primary-4); \n    width: 18px;\n    height: 18px;\n}\n\n/* Time Input Fields */\n/* Time Selection Container */\n.availability-specific-custom-time-selection {\n    background-color: var(--clr-grey-9); \n    padding: 20px;\n    border-radius: 10px;\n    border: 1px solid var(--grey-300);\n    box-shadow: var(--shadow-1); \n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    margin-bottom: 20px;\n    transition: all 0.3s ease-in-out;\n  }\n  \n  /* Grouping of Start and End Time */\n  .availability-specific-time-label-group {\n    display: flex;\n    justify-content: space-between; \n    gap: 1.5rem;\n  }\n  \n  /* Labels Styling */\n  .availability-specific-label {\n    font-size: 1.1rem;\n    font-weight: 600;\n    color: var(--clr-grey-2); \n    display: flex;\n    flex-direction: column; \n    gap: 0.5rem; \n  }\n  \n  /* Time Input Field Styling */\n  .availability-specific-time-input {\n    padding: 12px 16px;\n    border-radius: 8px;\n    border: 1px solid var(--grey-300); \n    font-size: 1.1rem;\n    font-weight: 500;\n    box-shadow: inset 0px 2px 4px rgba(0, 0, 0, 0.1);\n    transition: all 0.3s ease-in-out;\n    background-color: var(--clr-white);\n  }\n  \n  /* Time Input Hover and Focus */\n  .availability-specific-time-input:hover {\n    border-color: var(--clr-primary-6); \n  }\n  \n  .availability-specific-time-input:focus {\n    border-color: var(--clr-primary-6);\n    box-shadow: 0px 0px 5px rgba(0, 121, 107, 0.5); \n    outline: none;\n  }\n  \n  \n/* Recurring Options Container */\n.availability-specific-recurring-options {\n    padding: 15px;\n    border: 1px solid var(--clr-grey-300); \n    border-radius: var(--borderRadius); \n    background-color: var(--clr-grey-9); \n    margin-bottom: 20px;\n    box-shadow: var(--shadow-1); \n    transition: all 0.3s ease;\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n}\n\n/* Recurrence Checkbox Label */\n.availability-specific-checkbox-label {\n    font-size: 1rem;\n    color: var(--clr-grey-4); \n    font-weight: 600;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    cursor: pointer;\n}\n\n/* Checkbox Input */\n.availability-specific-checkbox-input {\n    transform: scale(1.2); \n    accent-color: var(--clr-primary-5); \n}\n\n/* Recurrence Type and End Date Row */\n.availability-specific-recurring-row {\n    display: flex;\n    justify-content: space-between;\n    gap: 1.5rem;\n}\n\n/* Labels for Recurrence and Date Inputs */\n.availability-specific-label {\n    display: flex;\n    flex-direction: column;\n    font-size: 1rem;\n    color: var(--clr-grey-3); \n    font-weight: 600;\n}\n\n/* Recurrence Type Select Input */\n.availability-specific-select {\n    padding: 12px 16px;\n    border-radius: var(--borderRadius);\n    border: 1px solid var(--clr-grey-300); \n    font-size: 1rem;\n    background-color: var(--clr-white); \n    box-shadow: inset 0px 2px 4px rgba(0, 0, 0, 0.1); \n    transition: border-color 0.3s ease-in-out;\n}\n\n/* Select Hover and Focus */\n.availability-specific-select:hover,\n.availability-specific-select:focus {\n    border-color: var(--clr-primary-6); \n    outline: none;\n    box-shadow: 0px 0px 5px rgba(0, 121, 107, 0.3); \n}\n\n/* End Recurrence Date Input */\n.availability-specific-date-input {\n    padding: 12px 16px;\n    border-radius: var(--borderRadius);\n    border: 1px solid var(--clr-grey-300); \n    font-size: 1rem;\n    background-color: var(--clr-white); \n    box-shadow: inset 0px 2px 4px rgba(0, 0, 0, 0.1); \n    transition: border-color 0.3s ease-in-out;\n}\n\n/* Date Input Hover and Focus */\n.availability-specific-date-input:hover,\n.availability-specific-date-input:focus {\n    border-color: var(--clr-primary-6); \n    outline: none;\n    box-shadow: 0px 0px 5px rgba(0, 121, 107, 0.3); \n}\n\n/* Validation Error */\n.validation-error {\n    color: var(--red-dark); \n    font-size: 0.95rem;\n    text-align: center;\n    margin-top: -10px;\n    margin-bottom: 20px;\n}\n\n/* Delete Confirmation Section */\n.delete-confirmation-section {\n    margin-top: 1rem;\n    margin-bottom: 1.5rem;\n    padding: 10px;\n    background-color: var(--clr-grey-9); \n    border: 1px solid var(--grey-300);\n    border-radius: 8px;\n  }\n  \n  /* Delete Confirmation Text */\n  .delete-confirmation-text {\n    font-size: 1rem;\n    font-weight: 500;\n    color: var(--clr-grey-4);\n    margin-bottom: 0.5rem;\n  }\n  \n  /* Delete Confirmation Label */\n  .delete-confirmation-label {\n    display: flex;\n    align-items: center;\n    font-size: 1rem;\n    font-weight: 500;\n    color: var(--clr-grey-3);\n  }\n  \n  .delete-confirmation-label input {\n    margin-right: 8px;\n  }\n  \n.delete-confirmation-section input {\n    transform: scale(1.2);\n    accent-color: var(--red-dark); \n}\n\n/* Modal Buttons */\n.availability-specific-modal-buttons {\n    display: flex;\n    justify-content: space-between;\n    gap: 1.2rem;\n}\n\n.availability-specific-modal-save-button,\n.availability-specific-modal-cancel-button {\n    flex: 1;\n    padding: 0.9rem 1.2rem;\n    font-size: 1.1rem;\n    border-radius: 8px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background-color 0.3s ease, transform 0.2s;\n}\n\n/* Save Button */\n.availability-specific-modal-save-button {\n    background-color: var(--clr-primary-5);\n    color: var(--clr-white);\n    border: none;\n}\n\n.availability-specific-modal-save-button:hover {\n    background-color: var(--clr-primary-3); \n    transform: scale(1.03);\n}\n\n/* Disabled Save Button */\n.availability-specific-modal-save-button:disabled {\n    background-color: var(--clr-grey-4);\n    cursor: not-allowed;\n    opacity: 0.7;\n}\n\n/* Cancel Button */\n.availability-specific-modal-cancel-button {\n    background-color: var(--clr-grey-6);\n    color: var(--clr-white);\n    border: none;\n}\n\n.availability-specific-modal-cancel-button:hover {\n    background-color: var(--clr-grey-4); \n    transform: scale(1.03);\n}\n\n/* Delete Button */\n.availability-specific-modal-delete-button {\n    background-color: palevioletred;\n    color: var(--clr-white);\n    border: none;\n    flex: 1;\n    padding: 0.9rem 1.2rem;\n    font-size: 1.1rem;\n    border-radius: 8px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background-color 0.3s ease, transform 0.2s;\n}\n\n.availability-specific-modal-delete-button:disabled {\n    background-color: var(--red-light);\n    cursor: not-allowed;\n}\n\n.availability-specific-modal-delete-button:hover {\n    background-color: var(--red-dark); \n}\n\n/* Responsive Design */\n\n@media (max-width: 768px) {\n    .availability-specific-modal-content {\n        padding: 1.2rem;\n        width: 95%;\n    }\n\n    .availability-specific-modal-buttons {\n        flex-direction: column;\n        gap: 0.8rem;\n    }\n\n    .availability-specific-modal-save-button,\n    .availability-specific-modal-cancel-button {\n        width: 100%;\n    }\n}\n\n/* Highlighted Date Styling */\n.highlighted-date {\n    font-weight: bold; \n    color: var(--clr-primary-5); \n    background-color: var(--clr-primary-9); \n    padding: 2px 6px; \n    border-radius: 4px; \n    box-shadow: var(--shadow-1); \n}\n\n@media (max-width: 768px) {\n    .availability-specific-recurring-row {\n        flex-direction: column;\n        gap: 1rem;\n    }\n}\n\n\n /* Responsive Time Input for Small Screens */\n @media (max-width: 768px) {\n    .availability-specific-time-label-group {\n      flex-direction: column;\n      gap: 1rem; \n    }\n  \n    .availability-specific-time-input {\n      width: 100%;\n    }\n  }\n\n  .availability-specific-modal-save-button.disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n    pointer-events: none;\n    background-color: #ccc; \n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
